import React from "react";
import utils from "../../utils/utils";
import "./style.less";
import Request from "../../utils/request";
const praised_icon = 'https://static.shihuocdn.cn/admin/files/20241029/ccb6c6caff2783d6ee264a93e088af3a.png'//选中后
const un_praised_icon = 'https://static.shihuocdn.cn/admin/files/20241029/437472759078c049024b762b9f409aad.png'//未点赞
const praised_animated = 'https://static.shihuocdn.cn/admin/files/20241029/8a40e7c94f8d375a920c52b5f2ab4207.svga'//点赞动效
const cancel_praised_animated = 'https://static.shihuocdn.cn/admin/files/20241029/f83b3847007875c51b0336c78af12616.svga'//取消点赞

export default class ItemView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAnimated: false,
      item: props.item || {}
    }
  }

  componentDidMount () {
    this.peloadingSvg(praised_animated)
  }

  peloadingSvg = (url) => {//预加载图片资源
    if (this.praiseHiddenRef) {
      import('svgaplayerweb').then((SVGA) => {
        const player = new SVGA.Player(this.praiseHiddenRef);
        const parser = new SVGA.Parser(this.praiseHiddenRef); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
        parser.load(url, (videoItem) => {
          player.loops = 1;
          player.setVideoItem(videoItem);
          player.startAnimation();
          player.onFinished(() => {
            player.stopAnimation(true);
            if (url.includes('/8a40e7c94f8d375a920c52b5f2ab4207')) {
              this.peloadingSvg(cancel_praised_animated)
            }
          });
        })
      });
    }
  }

  showPraiseSvga = (svgaUrl) => {
    if (this.praiseRef) {
      import('svgaplayerweb').then((SVGA) => {
        this.praiseRef.style.display = "flex";
        this.praiseImgRef.style.display = "none"; 
        const player = new SVGA.Player(this.praiseRef);
        const parser = new SVGA.Parser(this.praiseRef); // 如果你需要支持 IE6+，那么必须把同样的选择器传给 Parser。
        parser.load(svgaUrl, (videoItem) => {
          player.loops = 1;
          player.setVideoItem(videoItem);
          player.startAnimation();
          player.onFinished(() => {
            this.praiseRef.style.display = "none";
            this.praiseImgRef.style.display = "flex"; 
            player.stopAnimation(true)
          });
        })
      });
    }
  }

  praisePress(id, channel_type, status) {
    const reqUrl = "https://sh-gateway.shihuo.cn/v3/apps/app_swoole_common/praise"
    const that = this;
    Request({
      url: reqUrl,
      method: "get",
      withCredentials: true,
      params: {
        id,
        channel_type,
        status
      },
    }).then((res) => {
      const { data = {} } = res
      if (data.status == 0) {
        const { item = {} } = that.state
        if (item.is_praise) {
          item.is_praise = false
          item.praise = item.praise * 1 - 1
          that.showPraiseSvga(cancel_praised_animated)
          that.setState({ item })
        } else {
          item.is_praise = true
          item.praise = item.praise * 1 + 1
          that.showPraiseSvga(praised_animated)
          that.setState({ item })
        }
      } else if (data.status == 3) {
        window.Jockey.send("action", {
          url: "shihuo://www.shihuo.cn?route=login",
        });
      }
    });
  }
  render() {
    const { itemStyle, key, cardImgHeight, handleItemClick } = this.props
    const { showAnimated, item } = this.state
    const userInfo = item.user_info || {};
    return (
      <div
        className="card-item"
        key={key}
        style={itemStyle}
        onClick={() => {
          handleItemClick && handleItemClick()
        }}
      >
        <div
          className="card-item-content"
        >
          <div className="card-img-panel" style={{ height: cardImgHeight, width: '100%', backgroundImage: `url(${utils.formatImgUrl(item.img, this.props.webpSupport)})` }}>
            {item.duration ? <div className="play-view">
              <img className="play-icon" src={'https://static.shihuocdn.cn/admin/files/20230830/e862052a617f5580b4e5a62c40a1ae09.png'} />
              <div className="play-text">{item.duration}</div>
            </div> : null}
          </div>
          <div className="card-title" style={{ WebkitBoxOrient: "vertical" }}>{item.title || item.content}</div>
          <div className="card-info">
            <img className="avatar" src={utils.formatImgUrl(userInfo.avatar, this.props.webpSupport)} alt="" />
            <div className="username">{userInfo.hupu_username}</div>
            <div className="praise-view" onClick={(e) => {
              this.praisePress(item.id, item.channel_type, item.is_praise ? 2 : 1)
              e.stopPropagation()
            }}>
              <div className='praise-icon-content'>
                <img
                  className={"praise-icon"}
                  ref={ref => this.praiseImgRef = ref}
                  src={item.is_praise ? praised_icon : un_praised_icon}
                  alt=""
                />
                <div
                  className="praise-icon-svga"
                >
                  <div style={{ width: 0, height: 0, overflow: 'hidden', position: 'absolute', left: 0, top: 0}} ref={ref => this.praiseHiddenRef = ref} />
                  <div style={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center'}} ref={ref => this.praiseRef = ref} />
                </div>
              </div>
              <div className="praise-num" style={{ marginTop: utils.isAndroid() ? 1 : -1 }}>{item.praise}</div>
            </div>
          </div>
          {item.markText ?
            (<div className="mark-bg">
              <div className="mark-icon">{item.markText}</div>
            </div>) : null
          }
        </div>

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./components/pipeline-communityArticle/itemView.js